import clsx from "clsx";
import React, { ChangeEvent, useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { View } from "web/react/emo/view";
import * as styles from "./search.css";

export interface SearchProps {
    ariaControls?: string;
    onBlur: () => void;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onFocus?: () => void;
    placeholder: string;
}

export function Search({
    ariaControls,
    onBlur,
    onChange,
    onFocus,
    placeholder,
}: SearchProps): React.ReactElement {
    const [isFocused, setIsFocused] = useState<boolean>(false);

    return (
        <View
            paddingX="xs"
            paddingY="xxs"
            className={clsx(styles.searchField, { [styles.searchFieldFocused]: isFocused })}
        >
            <input
                data-testid="input"
                className={clsx(styles.input, styles.text)}
                type="text"
                onChange={onChange}
                onBlur={() => {
                    setIsFocused(false);
                    onBlur();
                }}
                onFocus={() => {
                    setIsFocused(true);
                    onFocus?.();
                }}
                placeholder={placeholder}
                aria-label={placeholder}
                aria-controls={ariaControls}
            />
            <View className={styles.icon}>
                <SVGIcon className={styles.icon} name="search-emo" />
            </View>
        </View>
    );
}
